import Vue from 'vue'
// import Antd from 'ant-design-vue'
import App from './App.vue'
import router from './router'
import request from './api/request'

// import 'ant-design-vue/dist/antd.css';
Vue.config.productionTip = false;
// Vue.use(Antd);

Vue.prototype.$request = request

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
